import { ObservableFromFetch } from "../ObservableFromFetch"

export interface AdditionalTest {
  AccountID: number
  LabAccount: string
  PanelCode: string
  Inactive: boolean
}

export function GetAdditionalTests(accountId: number, labAccount: string) {
  return ObservableFromFetch<AdditionalTest[]>(`GovOrder/GetAdditionalTests?AccountID=${accountId}&LabAccount=${labAccount}`)
}

export function UpdateAdditionalTests(accountId: number, labAccount: string, panels: string[], selectedPanels: string[]) {
  const requestBody: string = JSON.stringify(panels.map(p => {return { AccountID: accountId, LabAccount: labAccount, PanelCode: p, Inactive: selectedPanels.indexOf(p) == -1 }} ))
  return ObservableFromFetch<string>("GovOrder/UpdateAdditionalTests", requestBody, "PUT")
}
